// La fila de un video recién creado por el backend, lista para el visor y el lienzo: la
// misma lectura + firma que hacía Corregir voz, ahora compartida con "Pasar a 1080p"
// (ADR-2026-09-27-borrador-480p-y-pasar-a-1080p).
import { supabase } from './supabase';
import type { VideoCorregido } from '../components/CorregirVozSheet';

export async function firmarGenerada(path: string): Promise<string | null> {
  const { data } = await supabase.storage.from('generadas').createSignedUrl(path, 3600);
  return data?.signedUrl ?? null;
}

export async function cargarVideoGenerado(videoId: string, companyId: string): Promise<VideoCorregido | null> {
  const { data: fila } = await supabase
    .from('imagenes_generadas')
    .select('id, file_name, created_at, variante_id, variantes_ids, datos_generacion')
    .eq('id', videoId)
    .eq('id_company', companyId)
    .maybeSingle();
  if (!fila) return null;
  const f = fila as {
    id: string;
    file_name: string;
    created_at?: string;
    variante_id?: string | null;
    variantes_ids?: string[] | null;
    datos_generacion?: Record<string, unknown> | null;
  };
  const [signedUrl, optSignedUrl] = await Promise.all([
    firmarGenerada(`${companyId}/full/${f.file_name}`),
    firmarGenerada(`${companyId}/opt/${f.file_name.replace(/\.mp4$/i, '.png')}`),
  ]);
  if (!signedUrl) return null;
  return {
    id: f.id,
    fileName: f.file_name,
    signedUrl,
    optSignedUrl: optSignedUrl ?? undefined,
    videoUrl: signedUrl,
    isVideo: true,
    created_at: f.created_at,
    variante_id: f.variante_id ?? null,
    variantes_ids: f.variantes_ids ?? null,
    datos_generacion: f.datos_generacion ?? null,
  };
}
